import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// 全量导入Element Plus组件和样式
import ElementPlus, { ElMessage } from 'element-plus'
import 'element-plus/dist/index.css'
import axios from 'axios'

// 设置 axios 基础URL，所有请求通过前端代理转发到后端服务
axios.defaults.baseURL = '/api'

// 设置请求超时时间
axios.defaults.timeout = 300000 // 5分钟

// 添加请求拦截器 - 为所有请求添加认证令牌
axios.interceptors.request.use(
  (config) => {
    // 确保window和localStorage可用
    const token = typeof window !== 'undefined' && window.localStorage 
      ? window.localStorage.getItem('token') 
      : null
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 添加响应拦截器
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // 确保错误对象有正确的结构
    if (!error.response) {
      // 网络错误或请求被取消
      const enhancedError = new Error(error.message || '网络请求失败')
      enhancedError.originalError = error
      return Promise.reject(enhancedError)
    }
    
    if (error.response && error.response.status === 401) {
      // Token过期或无效，清除本地存储并重定向到登录页
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('user')
        window.localStorage.removeItem('isAuthenticated')
      }
    }
    return Promise.reject(error)
  }
)

// 创建应用实例
const app = createApp(App)

// 挂载axios到全局属性
app.config.globalProperties.$axios = axios

// 挂载路由插件
app.use(router)

// 注册Element Plus
app.use(ElementPlus)

// 将ElMessage挂载到全局
app.config.globalProperties.$message = ElMessage

// 全局错误处理
app.config.errorHandler = (err, instance, info) => {
  // 格式化错误信息，避免显示[object Object]
  let errorMessage = '未知错误'
  
  if (err && typeof err === 'object') {
    if (err.message) {
      errorMessage = err.message
    } else if (err.response && err.response.data) {
      const errorData = err.response.data
      errorMessage = errorData.message || errorData.error || JSON.stringify(errorData)
    } else {
      try {
        errorMessage = JSON.stringify(err)
      } catch (stringifyError) {
        errorMessage = String(err)
      }
    }
  } else if (typeof err === 'string') {
    errorMessage = err
  } else {
    errorMessage = String(err)
  }
  
  // 生产环境中可以添加错误上报，只在非生产环境输出详细错误
  if (process.env.NODE_ENV !== 'production') {
    console.error('全局错误捕获:', errorMessage, info)
    console.error('应用错误: ' + errorMessage)
  }
}

// 全局未捕获异常处理 - 检查window是否存在
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    let errorMessage = '全局未捕获异常'
    if (event.error) {
      errorMessage = event.error.message || String(event.error)
    } else if (event.message) {
      errorMessage = event.message
    }
    // 只在非生产环境输出详细错误
    if (process.env.NODE_ENV !== 'production') {
      console.error('全局未捕获异常:', errorMessage)
    }
  })

  // 全局Promise未捕获拒绝处理
  window.addEventListener('unhandledrejection', (event) => {
    let errorMessage = 'Promise未捕获拒绝'
    if (event.reason) {
      if (typeof event.reason === 'object' && event.reason.message) {
        errorMessage = event.reason.message
      } else {
        errorMessage = String(event.reason)
      }
    }
    // 只在非生产环境输出详细错误
    if (process.env.NODE_ENV !== 'production') {
      console.error('Promise未捕获拒绝:', errorMessage)
    }
    event.preventDefault() // 阻止默认行为
  })
}

// 最后挂载应用
app.mount('#app')
